<template>
    <div>
        <c-select ref="select" label="name"
                  :filterable="false"
                  :options="options"
                  @search="onSearch"
                  v-model="selected"
                  @input="inputChanged"
                  :disabled="disabled"
                  v-bind:name="'search_' + _uid">
            <template slot="no-options">
                <span class="text-danger">
                    {{ emptyMessage }}
                </span>
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center" @click="onSelected($event, { id: option.id, text: option.text, textEn: option.textEn })">
                    {{ isEnVersion ? option.textEn : option.text }}
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center"
                     @click="onSelected($event, { id: option.id, text: option.text, textEn: option.textEn })">
                    {{ isEnVersion ? option.textEn : option.text }}
                </div>
            </template>
        </c-select>
    </div>
</template>

<script>
    import vSelect from 'vue-select';
    import _ from 'lodash';
    import http from '../../services/http.service';
    import 'vue-select/dist/vue-select.css';

    export default {
        components: {
            'c-select': vSelect
        },
        props: {
            value: [Number, String],
            disabled: {
                type: Boolean,
                default: false
            },
            searchMinLength: {
                type: Number,
                default: 3
            }
        },
        data: function () {
            return {
                options: [],
                selected: { id: this.value },
                searchStr: ''
            }
        },
        methods: {
            onSearch(search, loading) {
                this.searchStr = search;
                if (search.length < this.searchMinLength) {
                    return
                }

                loading(true);
                this.search(loading, search, this);
            },
            search: _.debounce((loading, search, vm) => {
                const url = `/api/search/city?searchString=${encodeURIComponent(search)}`;
                http.get(url).then(result => {
                    vm.options = result.data;
                    loading(false);
                });
            }, 350),
            onSelected(event, selectedOption) {
                this.selected = selectedOption;
                this.$emit('input', this.selected.id);
            },
            inputChanged(event) {
                if (this.selected) {
                    this.$emit('input', this.selected.id);
                }

                if (event == null) { // Claer button has been clicked
                    this.$emit('input', null)
                }
            },
            loadInitialVal: function (caller) {
                if (!this.value) {
                    this.selected = null;
                    this.options = [];
                    return;
                }

                const url = `/api/search/city/${this.value}`;
                http.get(url).then(result => {
                    if (result.data) {
                        this.selected = result.data;
                    }
                });
            }
        },
        computed: {
            emptyMessage: function () {
                return (this.searchStr && this.searchStr.length >= this.searchMinLength) ? this.$t('searchDropdown.noResults') : this.$t('searchDropdown.minSearchChars', { searchMinLength: this.searchMinLength });
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            }
        },
        mounted: function () {
            if (this.value) {
                this.loadInitialVal();
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(newVal, oldVal) {
                    this.loadInitialVal();
                }
            }
        }
    }
</script>
